export default __webpack_public_path__ + "static/media/arrowRight.5c254e37.svg";